export default __webpack_public_path__ + "maps-examples-simple-map-view-thumbnail-960-e52afc930c022eaabc5bb0b5022e4a08.webp";